<template>
	<div class="header-label v-menu v-menu--inline">
		<div class="label">{{label}}:&nbsp;</div>
		<div class="value-container">
			<span v-if="isCash">$</span><count-to :startVal='0' :endVal="value" :duration='1500' :decimals="isCash ? 2 : 0"></count-to>
		</div>
	</div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import countTo from "vue-count-to"

	export default {
		components: {
			countTo
		},
		props: {
			value: {
				type: Number,
				default: 0.0
			},
			label: {
				type: String,
				required:true
			},
			isCash: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
			}
		},
		computed: {
			...mapGetters([
				'newOrderCount'
			]),
			notifications: function() {
				if (this.newOrderCount > 0) {
					return true
				}
				return false
			}
		}
	}
</script>
<style>
	.header-label {
		min-width: 100px;
		margin-left: 15px;
		font-size: 12px;
	}
	.header-label > .label{
		float: left;
		color: #747474;
	}
	.header-label .value-container {
		float: right;
	}
</style>
